import React, { useState } from 'react';
import { Modal, Button, Input, Form, Select } from 'antd';
import { toast } from 'react-toastify';
import { addUser } from '../../../../../services/users/usersApi';

const { Option } = Select;

const AjouterUser = ({ isOpen, onClose, onSubmit }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('');
    const [whatssap, setWhatssap] = useState('');
    const [photoProfil, setPhotoProfil] = useState(null);
    const [errors, setErrors] = useState({});
    const [roles, setRoles] = useState([]);

    const clearState = () => {
        setUsername('');
        setEmail('');
        setPassword('');
        setRole('');
        setWhatssap('');
        setPhotoProfil(null);
        setErrors({});
    };

    // const fetchRoles = async () => {
    //     try {
    //         const response = await getAllRoles(); // Fetch roles from the API
    //         setRoles(response.data); // Assuming response.data contains the array of roles
    //     } catch (error) {
    //         toast.error('Failed to fetch roles'); // Notify error
    //     }
    // };

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('email', email);
        formData.append('password', password);
        formData.append('role', 'admin');
        formData.append('whatssap', whatssap);
        if (photoProfil) {
            formData.append('photo_profil', photoProfil);
        }

        addUser(formData)
            .then((response) => {
                toast.success('User added successfully!');
                onSubmit(); // Refresh user list
                onClose(); // Close the modal
                clearState(); // Clear the form
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors); // Set errors from API response
                }
            });
    };

    return (
        <Modal
            title="Ajouter Utilisateur"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Ajouter
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item
                    label="Nom d'utilisateur"
                    validateStatus={errors.username ? 'error' : ''}
                    help={errors.username ? errors.username[0] : ''}
                >
                    <Input
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Nom d'utilisateur"
                        required
                    />
                </Form.Item>
                <Form.Item
                    label="Email"
                    validateStatus={errors.email ? 'error' : ''}
                    help={errors.email ? errors.email[0] : ''}
                >
                    <Input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                </Form.Item>
                <Form.Item
                    label="Mot de passe"
                    validateStatus={errors.password ? 'error' : ''}
                    help={errors.password ? errors.password[0] : ''}
                >
                    <Input.Password
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Mot de passe"
                        required
                    />
                </Form.Item>
                
                <Form.Item
                    label="WhatsApp"
                >
                    <Input
                        value={whatssap}
                        onChange={(e) => setWhatssap(e.target.value)}
                        placeholder="WhatsApp (optionnel)"
                    />
                </Form.Item>
                <Form.Item label="Photo de profil">
                    <Input
                        type="file"
                        onChange={(e) => setPhotoProfil(e.target.files[0])}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AjouterUser; 